'use strict';

/**
 * Wraps the standard date filter to work for moments instead
 */
customerZone.filter('formatMoment', ['$filter', function($filter) {
    return function(input, format, timezone) {
        if (!input) return '';
        return $filter('date')(input.toDate(), format, timezone);
    };
}]);
